// extracted by mini-css-extract-plugin
module.exports = {"customNavbar":"styles_customNavbar__2WebC","navbarButton":"styles_navbarButton__3Kwh7","websiteTitle":"styles_websiteTitle__5IGDV","dot":"styles_dot__2ziKQ"};